import React from 'react';

export function getPersistedStorage(key) {
    return JSON.parse(localStorage.getItem(key))
}

export default function usePersistedState(key, defaultValue) {
    const [state, setState] = React.useState(() => {
        const persistedState = localStorage.getItem(key);
        try {
            return  JSON.parse(persistedState)
        }
        catch {
            return  defaultValue;
        }
    });
    React.useEffect(() => {
        window.localStorage.setItem(key, JSON.stringify(state));
    }, [state, key]);
    return [state, setState];
}
